/**
 * Formata uma data para o padrão brasileiro DD/MM/YYYY.
 * Aceita objetos Date, strings no formato ISO 8601 ("2024-09-25T...")
 * e também strings no formato brasileiro ("25/09/2024...").
 *
 * @param {string | Date | number | null | undefined} dateInput - A data a ser formatada.
 * @returns {string} A data formatada como "DD/MM/YYYY" ou uma string vazia se a entrada for inválida.
 */
export function dataFormato(dateInput) {
    // 1. Validação de entrada nula ou indefinida
    if (!dateInput) {
        return "";
    }

    // 2. Tratamento especial para o formato de string "DD/MM/YYYY..."
    if (typeof dateInput === 'string') {
        // Usamos uma expressão regular para extrair a data no formato DD/MM/YYYY
        const regex = /^(\d{2})\/(\d{2})\/(\d{4})/;
        const partes = dateInput.match(regex);

        if (partes) {
            // Se encontrou o padrão, 'partes' será um array como: ["25/09/2024", "25", "09", "2024"]
            const dia = partes[1];
            const mes = partes[2];
            const ano = partes[3];

            // Retorna a data formatada diretamente, evitando o new Date() e problemas de fuso horário.
            return `${dia}/${mes}/${ano}`;
        }
    }

    // 3. Fallback para a lógica original (para ISO 8601, objetos Date, etc.)
    const dataObj = new Date(dateInput);

    // Valida se o fallback conseguiu criar uma data válida
    if (isNaN(dataObj.getTime())) {
        return "";
    }

    // Usa UTC para garantir consistência, ideal para datas ISO de backends
    const diaFormatado = String(dataObj.getUTCDate()).padStart(2, '0');
    const mesFormatado = String(dataObj.getUTCMonth() + 1).padStart(2, '0');
    const ano = dataObj.getUTCFullYear();

    return `${diaFormatado}/${mesFormatado}/${ano}`;
}